import videoService from '../api/media'

const state = {
    videos: [],
    video: null
}

const getters = {
    productionVideos: state => {
        return state.videos.filter(video => video.is_production);
    }
}

const actions = {
    search({commit, state}, {query}) {
        return videoService.search(query).then(response => {
            const result = response.data
            const videos = result.data ? result.data : result

            commit('setVideos', videos)

            return videos
        }, () => false)
    },

    get ({ commit, state }, mediaId) {
        commit('title/resetTitle', '', {root: true})
        return videoService.getVideo(mediaId).then(response => {
            const video = response.data
            commit('setVideo', video)
            commit('title/updateTitle', video.title, {root: true})
            return response.data
        }, () => false)
    }
}

const mutations = {
    setVideos(state, videos) {
        state.videos = videos.filter(video => {
            return video.type === 'youtube' || video.type === 'vimeo'
        })
        for (const video of state.videos) {
            video.Y = Math.floor(Math.random() * 150)
        }
    },
    setVideo(state, videoMedia) {
        state.video = videoMedia
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
